<template>
  <v-snackbar
    absolute
    style="bottom: 15%"
    :timeout="timeout"
    :color="color"
    :min-width="200"
    v-model="show"
  >
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn icon color="white" text v-bind="attrs" @click="show = false">
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
  
<script>
export default {
  props: {
    value: Boolean,
    text: String,
    color: String,
    timeout: {
      type: Number,
      default: 1200,
    },
  },
  data() {
    return {
      show: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.show = newVal;
    },
    show(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>
  